import { hasCalendarDateStarted } from '@utils/datetime';

export const examKey = (examSessionId, examSectionId) => `${examSessionId}-${examSectionId}`;

const STUDENT_TESTLET_NOT_STARTED = 0;

const examKeysMatching = (testSessions, testletIds) =>
  new Set(
    (testSessions || [])
      .flatMap((session) => session.testlets || [])
      .filter((testlet) => testletIds.has(testlet.id))
      .map((testlet) => examKey(testlet.exam_session, testlet.exam_section)),
  );

export const completedExamKeysFromLearnosity = (testSessions = [], completionStatus = []) => {
  const completeTestletIds = new Set((completionStatus || []).filter((status) => status.is_complete).map((status) => status.testlet_id));
  return examKeysMatching(testSessions, completeTestletIds);
};

export const notStartedExamKeysFromLearnosity = (testSessions = [], completionStatus = []) => {
  const statusByTestletId = new Map((completionStatus || []).map((row) => [row.testlet_id, row.status ?? STUDENT_TESTLET_NOT_STARTED]));
  return new Set(
    (testSessions || [])
      .flatMap((session) => session.testlets || [])
      .filter((testlet) => (statusByTestletId.get(testlet.id) ?? STUDENT_TESTLET_NOT_STARTED) === STUDENT_TESTLET_NOT_STARTED)
      .map((testlet) => examKey(testlet.exam_session, testlet.exam_section)),
  );
};

const completedIdsFromScores = (examsScore = {}) => {
  const ids = [];
  Object.values(examsScore || {}).forEach((exam) => {
    (exam || []).forEach((item) => {
      (item?.section_report || []).forEach((report) => {
        if (report.ended !== null) {
          ids.push(report.section_id);
        }
      });
    });
  });
  return new Set(ids);
};

export const testletIdByExamKeyFromSessions = (testSessions = []) => {
  const testletIdByExamKey = {};
  (testSessions || []).forEach((session) => {
    (session.testlets || []).forEach((testlet) => {
      testletIdByExamKey[examKey(testlet.exam_session, testlet.exam_section)] = testlet.id;
    });
  });
  return testletIdByExamKey;
};

export const getExamStartPath = ({ courseId, sectionId, examId, examSectionId, testletIdByExamKey }) => {
  const testletId = testletIdByExamKey?.[examKey(examId, examSectionId)];
  if (testletId) {
    return `/tests/course/${courseId}/section/${sectionId}/testsession/${examId}/testlet/${testletId}`;
  }
  return `/test/course/${courseId}/section/${sectionId}/exam/${examId}`;
};

export const splitExamSessions = (examList, examsScore, completedExamKeys, notStartedExamKeys) => {
  const completedExamSessions = [];
  const incompleteExamSessions = [];
  const useLearnosityKeys = completedExamKeys != null;
  const scoreIds = useLearnosityKeys ? null : completedIdsFromScores(examsScore);

  (examList || []).forEach((exam) => {
    const key = examKey(exam.exam_id, exam.id);
    const isComplete = useLearnosityKeys ? completedExamKeys.has(key) : scoreIds.has(exam.id);
    if (isComplete) {
      completedExamSessions.push(exam);
      return;
    }
    if (notStartedExamKeys != null && !notStartedExamKeys.has(key)) {
      return;
    }
    if (!hasCalendarDateStarted(exam.date)) {
      return;
    }
    incompleteExamSessions.push(exam);
  });

  return { completedExamSessions, incompleteExamSessions };
};
